<template>
  <div>
    <figure class="main-img-section">
      <img :src="mainImg" :alt="imgName">
      <MouseIcon class="floating-mouse-icon" />
      <div class="overlay"></div>
    </figure>
    <div class="content-separator"></div>
    <div class="main-content-section">
      <slot name="grid-content"></slot>
    </div>
  </div>
</template>

<script>
import MouseIcon from '@/assets/img/mouse-icon.svg'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  components: {
    MouseIcon
  },
  props: {
    mainImg: {
      type: String,
      required: true
    },
    imgName: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.initScrollAnimation()
  },
  methods: {
    initScrollAnimation () {
      gsap.to('.overlay', {
        opacity: 1,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: '.main-content-section',
          start: 'top bottom',
          end: 'top top+=100px',
          scrub: true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-img-section {
  width: 100vw;
  height: 100vh;
  background-color: #000;
  position: fixed;
  // position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .floating-mouse-icon {
    position: absolute;
    bottom: var(--main-space);
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    fill: white;
    #wheel {
      fill: white;
      animation: mouseLoop infinite 2s;
    }
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1A1A1A;
    opacity: 0;
    z-index: 9;
  }
}
.content-separator {
  height: 100vh;
  width: 100%;
}
.main-content-section {
  width: calc(100% - 2 * var(--main-space));
  position: relative;
  z-index: 10;
  margin: 0 auto;
  padding-top: calc(2 * var(--main-space));
  padding-bottom: calc(2 * var(--main-space));
}
</style>
